<template>
  <v-row no-gutters class="justify-space-between" :align="align">
    <v-col cols="4" class="sidebar-select-row-text text-left" :style="{ 'font-size': fontSize }">
      {{ $i18n.t(translationPath) }}:
      <sup style="color: red;" v-if="required">{{ '*' }} </sup>
    </v-col>
    <v-col cols="7" class="text-left">
      <data-input :data-type="dataTypeSelect" v-bind="selectProps" :menu-props="menuProps" v-model="computedValue">
      </data-input>
    </v-col>
  </v-row>
</template>

<script>
import DataInput from '@/components/DataInput';

export default {
  name: 'SidebarSelectRow',
  components: {
    DataInput,
  },
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    translationPath: {
      type: String,
      default: '',
    },
    menuProps: {
      type: Object,
      default: () => ({
        offsetY: true,
      }),
    },
    value: {
      type: [Array, Object, Number, String],
    },
    selectProps: {
      type: Object,
      required: false,
    },
    fontSize: {
      type: String,
      default: '13px',
    },
    align: {
      type: String,
      default: 'baseline',
    },
  },
  data: () => ({
    dataTypeSelect: {
      name: 'select',
    },
  }),
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(nV) {
        this.$emit('input', nV);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar-select-row-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  line-height: 20px;
  color: #202124;
}
::v-deep {
  .v-select__selections {
    flex-wrap: wrap !important;
  }
}
</style>
